import swRegister from './sw/service-worker-registration';

swRegister();
